import { css } from "styled-components";
import { getThemeMedia } from "../helpers";
export const getTableVariantStyle = (variant) => {
    return {
        primary: css `
			@media screen {
				@media (min-width: ${getThemeMedia("medium")}) {
					width: 100%;
				}
			}
		`,
        secondary: css `
			&[role='row']:nth-child(even) {
				background-color: var(--surface-primary);

				[role='cell']:last-child {
					background-color: var(--surface-primary);
				}
			}

			@media screen {
				@media (min-width: ${getThemeMedia("medium")}) {
					width: fit-content;
				}
			}
		`,
        simple: css `
			width: 100%;
		`,
    }[variant || "primary"];
};
//# sourceMappingURL=helpers.js.map